// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__27A-I","loaderOuter":"PageOverlayLoader_loaderOuter__1WeHs"};